<template>
	<v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
					<h1 v-if="$vuetify.breakpoint.smAndUp" class="band-color-blue interview-title">
            Introduction to The Interview
          </h1>
          <h1 v-else class="band-color-blue interview-title-sm">
            Introduction to The Interview
          </h1>
        </v-col>
				<v-col class="interview-color mb-5 main-text text-center">
					<p style="
							font-size: .9em;
							margin-top: 10px;
						"
						class="px-15">
						<span
							style="
								font-weight: bold;
								font-size: 1em;
							"
							class="italic">
							This is no time for ease and comfort.
							It is the time to dare and endure. <br />
						</span>
						<span
							style="
								font-weight: bold;
								font-size: .8em;
							"
						>
							-Winston Churchill
						</span>
					</p>
				</v-col>
				<v-col style="margin-top: -10px" class="main-text" cols="12">
					<p class="px-15 emphasis" style="font-size: 1.3em">
						Introduction:
					</p>
					<p class="px-15">
						Welcome. What you are about to begin is an unusual application of a relatively young literary genre: The Interview; part modern historical analysis, part casual conversation, and part deep psychological analysis of the key players of a cover-up, concealment and conspiracy that rivals no other realized in our lifetime. This is truly a unique utilization of the interview process. With that said it is also still an interview, limited by the medium itself to short rapid fire answers, and stingily edited responses.
					</p>
					<p class="px-15">
						This interview was drawn upon a few hundred pages of summary that I prepared in advance of the six days or sessions, and reviewed by H.L. before he formulated key questions. This summary itself was then condensed from the original narrative that I have spent no less than a year working on, and close to three years gathering notes for.
					</p>
					<p class="px-15">
						<span class="emphasis">The Basics:</span> The interview transpired over a six day period in a rural setting deep in the Ozark Mountains in southern Missouri during mid April of 2020. All responses were recorded by both H.L. and myself. It is only my tapes that I have drawn from, and attempted to edit for your exploration. The locations chosen to title each day of the interview represent the primary locus of the action of the events transpiring, though in many cases they are just a small part of an expansive reach defined.
					</p>
					<p class="px-15">
						The original goal was for freelance journalist and now friend H.L. (At his request his name is not given; instead only letters scrambled of both his first and last names are used) to formulate a marketable interview and shop it around to major periodicals for publication.
					</p>
					<p class="px-15">
						We encountered obvious and immediate problems with the outcome of this idea. The first was it is just too long for the medium itself. When I attempted to edit it down to size for him so that he could begin the final editing process, I quickly realized it had outgrown any marketable interview format, realizing if I continued to prune it any further then much of the value would be lost. The second problem is that neither of us had any experience in this process. H.L. is not an investigative reporter, and in fact while he has been a freelance journalist, he currently writes for a trade publication that has no parallel in any way to what we attempted here.
					</p>
					<p class="px-15">
						<span class="emphasis">The other problems,</span> the fatal ones, will become immediately clear to the reader. Those were security concerns and a general concern for his safety in attempting this; as many of the names included, and some of the names not included in this interview are influential enough to destroy his career, his livelihood and perhaps even his family. So it was with that in mind, considering the history of the wreckage <span class="italic">The Theorem: A Complete Answer to Human Behavior</span> has been responsible for that I ultimately decided to go at it alone. I have written my way into this mess, as you will see, perhaps this, then, is my futile attempt to write my way out of it. Still, the influence of H.L. cannot be overlooked on the pages that follow.
					</p>
					<p class="px-15">
						I have poured everything that is inside of me into the initial narrative; which then transformed into the interview that was then modified into the work presented here. With that said; I wish you safe travels as you embark on this very long, often emotional, and hopefully rewarding journey.
					</p>
				</v-col>
			</v-row>
	</v-container>
</template>

<script>
	export default {

	}
</script>

<style scoped>

</style>